var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopymail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.125 5.75C3.50368 5.75 3 6.25368 3 6.875V18.125C3 18.7463 3.50368 19.25 4.125 19.25H19.875C20.4963 19.25 21 18.7463 21 18.125V6.875C21 6.25368 20.4963 5.75 19.875 5.75H4.125ZM1.5 6.875C1.5 5.42525 2.67525 4.25 4.125 4.25H19.875C21.3247 4.25 22.5 5.42525 22.5 6.875V18.125C22.5 19.5747 21.3247 20.75 19.875 20.75H4.125C2.67525 20.75 1.5 19.5747 1.5 18.125V6.875Z",
    fill: "#8493B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.65799 7.53954C4.91229 7.21258 5.3835 7.15368 5.71046 7.40799L12 12.2999L18.2895 7.40799C18.6165 7.15368 19.0877 7.21258 19.342 7.53954C19.5963 7.86651 19.5374 8.33771 19.2105 8.59201L12.4605 13.842C12.1896 14.0527 11.8104 14.0527 11.5395 13.842L4.78954 8.59201C4.46258 8.33771 4.40368 7.86651 4.65799 7.53954Z",
    fill: "#8493B2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopymail);
export default __webpack_public_path__ + "static/media/copymail.8339e852ff4d42fe2caa361247d151ec.svg";
export { ForwardRef as ReactComponent };